import React from 'react';
import { connect } from 'react-redux';

import { getCurrentBookSpreads, getExtraSpreadIdAfter, isExtraSpread } from 'redux/selectors/books';
import { getActiveOrderId, getActiveSpreadId } from 'redux/selectors/app';
import * as appActions from 'redux/reducers/app';
import * as ordersActions from 'redux/reducers/orders';

import Add from 'components/icons/add';
import Remove from 'components/icons/remove';

import styles from './styles.scss';

@connect(
  (state, { id }) => ({
    orderId: getActiveOrderId(state),
    spreads: getCurrentBookSpreads(state),
    currentSpread: getActiveSpreadId(state),
    isExtraSpread: isExtraSpread(state, id),
    extraSpreadAfterId: getExtraSpreadIdAfter(state, id),
  }),
  {
    setActiveSpread: appActions.setActiveSpread,
    enableExtraSpread: ordersActions.enableExtraSpread,
    disableExtraSpread: ordersActions.disableExtraSpread,
  }
)
export default class SpreadExtraButton extends React.PureComponent {
  addSpread = () => {
    const { orderId, enableExtraSpread, extraSpreadAfterId, setActiveSpread } = this.props;

    if (extraSpreadAfterId) {
      enableExtraSpread(orderId, extraSpreadAfterId);
      setActiveSpread(extraSpreadAfterId);
    }
  };

  removeSpread = () => {
    const { orderId, spreads, isExtraSpread, currentSpread, disableExtraSpread, setActiveSpread } = this.props;

    if (isExtraSpread) {
      const previousSpread = spreads.get(spreads.findIndex(spread => spread.get('id') === currentSpread) - 1);
      setActiveSpread(previousSpread.get('id'));
      disableExtraSpread(orderId, currentSpread);
    }
  };

  render() {
    const { isExtraSpread, extraSpreadAfterId } = this.props;

    return (
      <div className={styles.buttons}>
        {isExtraSpread || extraSpreadAfterId ? (
          <button onClick={this.addSpread} disabled={!extraSpreadAfterId}>
            <div className={styles.inner}>
              <Add />
            </div>
          </button>
        ) : null}
        {isExtraSpread ? (
          <button onClick={this.removeSpread}>
            <div className={styles.inner}>
              <Remove />
            </div>
          </button>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/spread-extra-buttons/index.js